import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export function Home() {
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuth();
  const status = useQuery({
    queryKey: ['onboarding-status'],
    queryFn: api.onboardingStatus,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    const data = status.data;
    if (!data) return;
    if (data.mode === 'licensing') {
      navigate({ to: '/licensing' });
      return;
    }
    if (data.mode === 'normal') {
      if (authLoading) return;
      if (user) {
        navigate({ to: user.role === 'admin' ? '/admin' : '/chat' });
      } else {
        navigate({ to: '/login' });
      }
    } else {
      const step = data.step === 'done' ? 'finish' : data.step;
      navigate({ to: '/onboarding/$step', params: { step } });
    }
  }, [status.data, authLoading, user, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-center text-sm text-foreground-muted">
        {status.isLoading
          ? '서버 상태 확인 중…'
          : status.error
            ? '서버에 연결할 수 없어요'
            : '잠시만요…'}
      </div>
    </div>
  );
}
